export default "__VITE_PUBLIC_ASSET__4a861c15__"